import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import Slider from "rc-slider";
import Form1 from "./Form1";
import Form2 from "./Form2";
import Form3 from "./Form3";
import { initialProfileValues, ProfileSchema1, ProfileSchema2, ProfileSchema3 } from "../../../schemas/ProfileSchema";
import { useAuth } from "../../../context/AuthContext";
import Spinner from "../../Loader/Spinner";
import { useForm } from "../../../hooks/useForm";
import { useLocation } from "../../../hooks/useLocation";

const ProfileForm = ({ close }) => {

  const steps = [{ schema: "" }, { schema: ProfileSchema1 }, { schema: ProfileSchema2 }, { schema: ProfileSchema3 }];
  const { updateUserProfile, loading, setUploadImage, done, setValues } = useAuth();
  const { form, formData, onChange, isFormValid, validateOnSubmit } = useForm({
    propertyType: "",
    ownershipType: "",
  });

  const { locationData } = useLocation();

  const [rooms, setRooms] = useState([]);
  const [neededRooms, setNeededRooms] = useState([]);


  const [step, setStep] = useState(1);
  const [vSchema, setVSchema] = useState(steps[1].schema);

  const handleNext = () => {
    setStep(step + 1);
    setVSchema(steps[step + 1].schema);
  };

  const isLastStep = () => {
    return step === steps.length - 1;
  };

  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
      setVSchema(steps[step - 1].schema);
    }
  };

  const handleSubmit = async (values, formikBag) => {
    const { setSubmitting } = formikBag;
    if (!isLastStep()) {
      setSubmitting(false);
      if (!isFormValid() && step !== 1) {
        validateOnSubmit();
        return;
      } else {
        handleNext();
        return;
      }
    }
    await updateUserProfile(false);
    setValues({ ...values, ...formData, rooms: neededRooms });
  };

  useEffect(() => {
    if (locationData) {
      const { region, city, country, postal_code } = locationData;
      initialProfileValues['country'] = country;
      initialProfileValues['state'] = region;
      initialProfileValues['city'] = city;
      initialProfileValues['zipCode'] = postal_code || '';
    }
  }, [locationData])

  useEffect(() => {
    done && close();
  }, [close, done]);


  const getNavigationButtons = (back, formikBag) => {
    const { handleSubmit } = formikBag;

    return (
      <div className="flex fap-4 items-center gap-4">
        {back ? (
          <button
            onClick={handleBack}
            type="button"
            className="w-[calc(200px/2)] md:w-[calc(310px/2)] h-[50px] text-primary border-primary border  rounded mt-12 bg-white text-base font-semibold"
          >
            Go back
          </button>
        ) : (
          <div></div>
        )}
        <button
          onClick={handleSubmit}
          type="submit"
          className="w-[calc(200px/2)] md:w-[calc(310px/2)] h-[50px] bg-primary rounded mt-12 text-white text-base font-semibold"
        >
          {isLastStep() && !loading ? "Complete" : loading ? <Spinner /> : "Next"}
        </button>
      </div>
    );
  };

  return (
    <div className="w-full h-full flex flex-col items-center justify-center px-20 py-10">
      <Formik enableReinitialize={true} onSubmit={handleSubmit} validationSchema={vSchema} initialValues={{ ...initialProfileValues, ...formData }}>
        {({ handleSubmit, values, isSubmitting, isValid }) => (
          <>
            <Slider
              value={(step * 100) / steps.length}
              trackStyle={{ backgroundColor: "#0086E6" }}
              handleStyle={{ backgroundColor: "#0086E6", border: "solid 2px #0086E6", opacity: 1 }}
              marks={{
                [(step * 100) / steps.length]: <>{(step * 100) / steps.length}%</>,
              }}
            />
            {step === 1 ? (
              <Form1 values={values} />
            ) : step === 2 ? (
              <Form2 values={values} onChange={onChange} form={form} setUploadImage={setUploadImage} />
            ) : (
              <Form3 values={values} rooms={rooms} setRooms={setRooms} setNeededRooms={setNeededRooms} />
            )}{" "}
            {getNavigationButtons(step > 1, { isSubmitting, isValid, handleSubmit })}
          </>
        )}
      </Formik>
    </div>
  );
};

export default ProfileForm;
